import Preloader from 'lib/Preloader/';

export const PageLoader = (): React.ReactElement => {
  return (
    <div
      className="w-full h-full fixed bottom-0 top-[60px] right-0 left-[60px] z-80"
      id="loader-container"
      style={{ display: 'none' }}
    >
      <Preloader />
    </div>
  );
};
